/**
 * dialog closedby polyfill based on https://github.com/tak-dcxi/dialog-closedby-polyfill
 *
 * @license MIT
 *
 * Copyright (c) 2025 Takahiro Arai
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

if (!("closedBy" in HTMLDialogElement.prototype)) {
  addEventListener("click", (event) => {
    const source = event.composedPath()[0];
    if (
      source instanceof HTMLDialogElement &&
      source.getAttribute("closedby") === "any"
    ) {
      const rect = source.getBoundingClientRect();
      const { clientX: x, clientY: y } = event;
      const inside =
        rect.top <= y && y <= rect.bottom && rect.left <= x && x <= rect.right;

      if (!inside) source.close();
    }
  });
}
